import type { CSSProperties, FunctionComponent } from "react"

import { useRef } from "react"

import { Button } from "@jobteaser/spark/components/Button"
import { Text } from "@jobteaser/spark/components/Text"

import cardBackground from "@/modules/corporate/images/card-background.png"
import { Link as NextLink } from "@/modules/routing/components/Link"
import { useLazyAssetUrl } from "@/modules/staticAssets/useLazyAssetUrl"

import styles from "./RecruitAdInsert.module.css"

type RecruitAdInsertProps = {
  title: string
  description: string
  cta: {
    href: string
    label: string
    onClick: () => void
  }
}

export const RecruitAdInsert: FunctionComponent<RecruitAdInsertProps> = ({ title, description, cta }) => {
  const ref = useRef<HTMLElement>(null)
  const lazyBase64AssetUrl = useLazyAssetUrl({ asset: cardBackground, ref })
  const insertStyle = { "--backgroundImage": `url(${lazyBase64AssetUrl})` } as CSSProperties

  return (
    <aside ref={ref} style={insertStyle} className={styles.main}>
      <div className={styles.content}>
        <div className={styles.text}>
          <Text className={styles.title} variant="display2" weight="bold">
            {title}
          </Text>
          <Text className={styles.description} variant="body1" weight="regular">
            {description}
          </Text>
        </div>
        <Button
          renderComponent={NextLink}
          className={styles.cta}
          href={cta.href}
          onBackground="dark"
          onClick={cta.onClick}
          variant="primary"
        >
          {cta.label}
        </Button>
      </div>
    </aside>
  )
}
